import React, { JSX, useState } from 'react';
import { isEmpty } from 'lodash';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';

import './InputField.scss';

export interface LzPInput {
  fluid?: boolean;
  required?: boolean;
  type?: string;
  autoFocus?: boolean;
  placeholder?: string;
  label?: string;
  name?: string;
  icon?: JSX.Element;
  id?: string;
  className?: string;
  style?: React.CSSProperties;
  formErrors?: any;
  value?: string;
  hintText?: string;
  disabled?: boolean;
  readonly?: boolean;
  compact?: boolean;
  noAutocomplete?: boolean;
  size?: 'small' | 'medium';
  variant?: 'outlined' | 'filled' | 'standard';
  onChange?: (name: string, value: string) => void;
}

const LzXInputField = (props: LzPInput) => {
  const isPasswordField = 'password' === props.type;
  const [readonlyState, setReadonlyState] = useState(isPasswordField);

  if (typeof props.value === 'undefined') {
    return <CircularProgress />;
  }

  const theName = props.name || '';
  const theId = props.id || 'id_' + theName;
  const inputProps: {
    min?: number;
    max?: number;
    step?: number;
    placeholder?: string;
    readOnly?: boolean;
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  } = {};
  var theType = props.type || 'text';
  if ('year' === theType) {
    theType = 'number';
    inputProps.min = 1900;
    inputProps.max = 2099;
    inputProps.step = 1;
    inputProps.placeholder = 'YYYY';
  }
  // This below is done because Chrome does not follow the autocomplete instructions and this below is a hack arround it
  // see this stackoverflow answer: https://stackoverflow.com/a/26931463
  if (isPasswordField) {
    inputProps.readOnly = !!props.readonly || readonlyState;
    inputProps.onFocus = () => setReadonlyState(false);
    inputProps.onBlur = () => setReadonlyState(true);
  }

  const autoComplete =
    props.noAutocomplete || isPasswordField ? 'dont-show' : 'on';

  const labelShrinked = 'date' === theType || 'time' === theType;

  const hasError = props.formErrors && props.formErrors[theName];

  const handleOnChange = (val: string): void => {
    if (props.onChange) {
      props.onChange(theName, val);
    }
  };

  return (
    <TextField
      id={theId}
      name={theName}
      type={theType}
      fullWidth={props.fluid}
      required={props.required}
      autoFocus={props.autoFocus}
      autoComplete={autoComplete}
      placeholder={props.placeholder}
      label={props.label}
      helperText={
        hasError
          ? props.formErrors[theName]
          : props.hintText || props.placeholder || ''
      }
      value={props.value}
      inputProps={inputProps}
      className={
        'lz-base-field lz-input-field ' +
        (props.compact ? 'lz-compact ' : '') +
        (props.className || '')
      }
      style={props.style}
      size={props.size || 'small'}
      variant={props.variant || 'standard'}
      onChange={(evt) => handleOnChange(evt.target.value)}
      error={props.formErrors && props.formErrors[theName]}
      InputLabelProps={
        labelShrinked || !isEmpty(props.value) ? { shrink: true } : {}
      }
      disabled={props.disabled}
    />
  );
};

export default LzXInputField;
